import getBasePath from '../../functions/api-resource';

const basePath = getBasePath('api', 'configuracao-calendario-aprovacao');

const configuracaoCalendarioAprovacaoActions = {
  atualizar: { method: 'PUT', url: `${basePath}` },
  pesquisar: { method: 'GET', url: `${basePath}` },
};

export default resource => resource(`${basePath}`, {}, configuracaoCalendarioAprovacaoActions);



// WEBPACK FOOTER //
// ./src/common/resources/configuracao/configuracao-calendario-aprovacao.js